/**
 * Retourne la largeur minimale et la hauteur minimale requise.
 * @param {object} param0
 * @param {object} param0.formats
 */
export default function configurationCoversGetSizes({ formats }) {
  return Object.values(formats).reduce(
    function ({ minWidth, minHeight }, format) {
      return {
        minWidth: Math.max(minWidth, format.min_width),
        minHeight: Math.max(minHeight, format.min_height),
      };
    },
    { minWidth: -Infinity, minHeight: -Infinity },
  );
}
